module.exports = __webpack_public_path__ + "static/media/visualizacion-logo-caracol-tv-1983-1987@3x.7784a0b5.png";